import type { IconData } from '@stacksjs/iconify-core'

export const playCircleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m4.126-8.254c.213-.153.397-.348.54-.575c.606-.965.365-2.27-.54-2.917L10.07 5.356A1.9 1.9 0 0 0 8.972 5C7.883 5 7 5.941 7 7.102v5.796c0 .417.116.824.334 1.17c.607.965 1.832 1.222 2.737.576zm-5.2-4.616l4.055 2.898l-4.056 2.897z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default playCircleF
